var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.5016 9.99707V12.1671C18.5016 12.6971 18.7116 13.2071 19.0916 13.5871L19.9116 14.4071C20.2916 14.7871 20.5016 15.2971 20.5016 15.8271V16.9971C20.5016 19.8471 19.1216 21.7971 16.0116 21.9771L15.9916 18.9871C15.9816 17.8871 15.0916 16.9971 13.9916 16.9971H9.98159C8.87159 16.9971 7.98159 17.8971 7.98159 18.9971L7.99159 21.9771C4.83159 21.7971 3.50159 19.8471 3.50159 16.9971V6.99707C3.50159 3.99707 4.97159 1.99707 8.50159 1.99707H15.5016C18.9716 1.99707 20.5016 3.99707 20.5016 6.99707V7.99707C20.5016 8.54707 20.0516 8.99707 19.5016 8.99707C18.9516 8.99707 18.5016 9.44707 18.5016 9.99707Z",
    fill: "#234CE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0082 21.9771C15.8482 21.9871 15.6781 21.9971 15.4981 21.9971H8.49815C8.31815 21.9971 8.14815 21.9971 7.98815 21.9771L7.97815 18.9971C7.97815 17.8971 8.86815 16.9971 9.97815 16.9971H13.9881C15.0881 16.9971 15.9781 17.8871 15.9881 18.9871L16.0082 21.9771Z",
    fill: "#234CE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 8.53125H7.96875C7.55875 8.53125 7.21875 8.19125 7.21875 7.78125C7.21875 7.37125 7.55875 7.03125 7.96875 7.03125H13.9688C14.3788 7.03125 14.7188 7.37125 14.7188 7.78125C14.7188 8.19125 14.3888 8.53125 13.9688 8.53125Z",
    fill: "#234CE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRam);
export default __webpack_public_path__ + "static/media/ram.ddb5e1b35a897af1d36ef9911d5748c5.svg";
export { ForwardRef as ReactComponent };